/**
 * Blocos que o painel oferece ao montar um perfil.
 *
 * O backend não conhece os blocos do Volto, então a lista sai do
 * `config.blocks.blocksConfig`. Ficam de fora os blocos `restricted: true`
 * (ninguém adiciona pelo BlockChooser — ex.: os de slot) e os obrigatórios,
 * que todo perfil recebe.
 */
export type BlocoOpcao = { id: string; title: string; group?: string };

export const catalogoBlocos = (
  blocksConfig: Record<string, any> | undefined,
  obrigatorios: string[] = [],
): BlocoOpcao[] =>
  Object.values(blocksConfig ?? {})
    .filter(
      (bloco) =>
        bloco?.id &&
        bloco.restricted !== true &&
        !obrigatorios.includes(bloco.id),
    )
    .map((bloco) => ({
      id: bloco.id,
      title: typeof bloco.title === 'string' ? bloco.title : bloco.id,
      group: bloco.group,
    }))
    .sort((a, b) => a.title.localeCompare(b.title, 'pt-BR'));

export default catalogoBlocos;
